import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components';

const GhostInput = styled.input`
  &.ghost-input {
    display: none;
  }
`;

type AttachmentGhostInputProps = InputHTMLAttributes<HTMLInputElement>;

export const AttachmentGhostInput = React.forwardRef<
  HTMLInputElement,
  AttachmentGhostInputProps
>(({ className = '', ...props }, ref) => (
  <GhostInput {...props} ref={ref} className={`ghost-input ${className}`} />
));
